export const experienceData = [
    {
        id: 1,
        company: 'ASAP Electronics GmbH, Ingolstadt',
        jobtitle: 'Software Developer in E-Drive Data Analysis Division',
        startYear: 'Mar. 2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Avatera Medical GmbH, Ilmenau',
        jobtitle: 'Intern in Test and Tool Development Division',
        startYear: 'Jun. 2022',
        endYear: 'Dec. 2022'
    },
    {
        id: 3,
        company: 'Steinbeis GmbH, Ilmenau',
        jobtitle: 'Intern',
        startYear: 'Jan. 2022',
        endYear: 'Apr. 2022'
    },
];
